// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"_1esA0","companyAvatar":"_2Os1B"};